'use strict';

var filters = angular.module('amexReconciliationApp');

filters.filter('allocationPercentage',
  function truncatePercentage() {
    return function (input) {
      return (Math.floor(input*100))/100;
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/allocationPercentageFilter.js
// module id = 550
// module chunks = 0